import React from "react";

const BagIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5468 6.65912H23.2724L24.998 22.3287C25.0306 22.6644 24.6562 22.9537 24.184 22.9537L1.81595 23C1.34384 23 0.969415 22.7107 1.00197 22.375L2.59735 6.70542H4.38812"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.035 7.89746H10.9163"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2908 9.80694V4.86532C18.2908 2.72434 15.914 1 12.9837 1C10.0534 1 7.67651 2.73592 7.67651 4.86532V9.80694"
        stroke="#3F3F3F"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BagIcon;
